import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button, FormGroup, Col, FormControl, Form } from 'react-bootstrap';

class ForgetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
    };
  }

  btnClick() {
    this.props.show();
    let obj = {
      email: this.state.email,
    };
    let curentState = this;
    this.props.forgetPassword(obj.email).then(
      function (res) {
        if (res.payload.data.statusCode === 200) {
          //send new password to mail
          if (res.payload.data !== null) {
            curentState._generatePassword(res.payload.data.result.id);
          }
        }
      },
      function (err) {
        console.log(err);
        curentState.props.hide();
      }
    );
  }

  _generatePassword(memberid) {
    let curentState = this;
    this.props.generatePassword(memberid).then(
      function (res) {
        if (res.payload.data.statusCode === 200) {
          curentState.props.showMessage({
            message: res.payload.data.result,
            type: true,
          });
          setTimeout(() => curentState.props.history.push('/login'), 2000);

          curentState.props.hide();
        }
      },
      function (err) {
        console.log(err);
        curentState.props.hide();
      }
    );
  }

  render() {
    return (
      <Form>
        <div className="form-horizontal">
          <div className="box-body">
            <div style={{ border: '1px solid #ddd', padding: '5px' }}>
              <FormGroup controlId="formHorizontalUserId">
                <Col sm={12}>
                  <FormControl
                    type="text"
                    placeholder="Email"
                    id="Email"
                    onChange={(event) =>
                      this.setState({ email: event.target.value })
                    }
                  />
                </Col>
              </FormGroup>

              <FormGroup>
                <Col sm={12}>
                  <Button
                    bsStyle="success"
                    block
                    onClick={this.btnClick.bind(this)}
                  >
                    Submit
                  </Button>
                </Col>
              </FormGroup>
            </div>
            <br />
            <FormGroup>
              <Col sm={12}>
                <Link to="/" className="btn btn-warning pull-right">
                  Back
                </Link>
              </Col>
            </FormGroup>
          </div>
        </div>
      </Form>
    );
  }
}

export default ForgetPassword;
